<p>create-lock-dates-modal works!</p>
